function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Container, CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card, Pill } from "../../components/analytics-kit";
import { Link } from "react-router-dom";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import account from "../../data/account";
import endpoints from "../../endpoints";
import { AuthBase } from "../../../plunk/service/auth-base";
import { hasTenantFeature, adBillingMode, ownAdAccounts } from "../../functions/tenant-features";
import { adSvc, usd } from "./common";

/*
 * Flight detail (§96 follow-through — the list/detail slice). One page,
 * two modes by status:
 *  Draft      → resume: slot manifest + Validate/Review + Submit (the same
 *               contract blocks as the wizard's locked phase).
 *  Submitted+ → live per-cell progress (GET /flights/{id} cells; the poll
 *               nudges server-side progress).
 * Flight ids are serialized as STRINGS by the controller (>2^53 safe).
 */

// Scoped styling for the flight-detail page (the builder's fb-* CSS lives in
// its own component, so this page carries its own polished style set).
const FD_CSS = `
@keyframes fd-spin{to{transform:rotate(360deg)}}
@keyframes fd-fade{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}
.fd-wrap{max-width:940px;margin:0 auto;padding:6px 20px 48px;animation:fd-fade .3s ease}
.fd-head{display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;margin:4px 0 18px}
.fd-htitle{display:flex;align-items:center;gap:12px;min-width:0}
.fd-back{width:34px;height:34px;border-radius:9px;border:1px solid var(--plk-border,#e7e2dc);background:var(--plk-surface,#fff);display:grid;place-items:center;color:var(--plk-text-muted,#7d7b88);cursor:pointer}
.fd-back:hover{border-color:var(--plk-accent,#ff6358);color:var(--plk-accent,#ff6358)}
.fd-back .material-icons{font-size:19px}
.fd-h1{font-size:19px;font-weight:700;margin:0;color:var(--plk-text,#1c1b22);letter-spacing:-.2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.fd-actions{display:flex;align-items:center;gap:6px;flex-wrap:wrap}
.fd-btn{border:1px solid var(--plk-border,#e7e2dc);background:var(--plk-surface,#fff);color:var(--plk-text,#1c1b22);font-size:12.5px;font-weight:600;padding:6px 12px;border-radius:8px;cursor:pointer;white-space:nowrap}
.fd-btn:hover{border-color:var(--plk-accent,#ff6358);color:var(--plk-accent-ink,#e0473c)}
.fd-btn.danger{color:var(--plk-danger,#b42318)}.fd-btn.danger:hover{border-color:var(--plk-danger,#b42318)}
.fd-btn:disabled{opacity:.5;cursor:default}
.fd-pill{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;padding:5px 11px;border-radius:999px}
.fd-pill.ok{background:var(--plk-success-soft,#e3f5ea);color:var(--plk-success,#2f9e5f)}
.fd-pill.info{background:var(--plk-accent-soft,#ffece9);color:var(--plk-accent-ink,#e0473c)}
.fd-pill.warn{background:var(--plk-warn-soft,#fbeeda);color:#7a5310}
.fd-pill.err{background:var(--plk-danger-soft,#fbe6e5);color:var(--plk-danger,#b42318)}
.fd-note{display:flex;gap:9px;align-items:flex-start;padding:11px 14px;border-radius:10px;background:var(--plk-accent-soft,#ffece9);border:1px solid var(--plk-accent-line,#ffd4cf);color:var(--plk-accent-ink,#e0473c);font-size:12.5px;margin-bottom:16px}
.fd-summary{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:12px;margin-bottom:18px}
.fd-tile{border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;padding:13px 15px;background:var(--plk-surface,#fff);min-width:0}
.fd-tile .lbl{font-size:10px;text-transform:uppercase;letter-spacing:.5px;color:var(--plk-text-muted,#7d7b88);font-weight:700}
.fd-tile .val{font-size:14px;font-weight:600;margin-top:5px;color:var(--plk-text,#1c1b22);word-break:break-word}
.fd-tile .val a{color:var(--plk-accent-ink,#e0473c);text-decoration:none}
.fd-card{border:1px solid var(--plk-border,#e7e2dc);border-radius:16px;background:var(--plk-surface,#fff);padding:22px;box-shadow:0 1px 2px rgba(28,27,34,.04)}
.fd-hero{display:flex;align-items:center;gap:20px;margin-bottom:20px;flex-wrap:wrap}
.fd-ring{width:88px;height:88px;border-radius:50%;flex:none;display:grid;place-items:center;background:conic-gradient(var(--plk-accent,#ff6358) calc(var(--pct,0)*1%),var(--plk-border,#e7e2dc) 0);transition:background .6s ease}
.fd-ring.done{background:conic-gradient(var(--plk-success,#2f9e5f) 100%,var(--plk-success,#2f9e5f) 0)}
.fd-ring.fail{background:conic-gradient(var(--plk-danger,#d64541) 100%,var(--plk-danger,#d64541) 0)}
.fd-hero h2.fail{color:var(--plk-danger,#b42318)}
.wa-pill.danger.solid{background:var(--plk-danger,#d64541);color:#fff;font-weight:700}
.fd-ring-in{width:68px;height:68px;border-radius:50%;background:var(--plk-surface,#fff);display:grid;place-items:center}
.fd-ring .pct{font-size:18px;font-weight:700;font-family:ui-monospace,Menlo,monospace;color:var(--plk-text,#1c1b22)}
.fd-hero h2{font-size:17px;font-weight:700;margin:0 0 4px;color:var(--plk-text,#1c1b22)}
.fd-hero p{margin:0;font-size:13px;color:var(--plk-text-muted,#7d7b88);line-height:1.5;max-width:520px}
.fd-list{border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;overflow:hidden}
.fd-mx th,.fd-mx td{white-space:nowrap}.fd-mx td.m{font-weight:600}
.fd-fails{margin-top:16px}.fd-fails-h{font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--plk-text-muted,#7d7b88);margin-bottom:6px}
.fd-fail{display:flex;gap:10px;padding:10px 0;border-top:1px solid var(--plk-border,#e7e2dc)}.fd-fail b{font-size:13px;color:var(--plk-text,#1c1b22)}.fd-fail .why{font-size:12px;color:var(--plk-danger,#b42318);margin-top:2px;line-height:1.45}.fd-fail .why b{color:var(--plk-danger,#b42318);font-size:12px}
.fd-row{display:flex;align-items:center;gap:12px;padding:12px 14px;border-top:1px solid var(--plk-border,#e7e2dc);flex-wrap:wrap}
.fd-row:first-child{border-top:none}
.fd-pi{width:26px;height:26px;border-radius:50%;flex:none;display:grid;place-items:center}
.fd-pi.ok{background:var(--plk-success-soft,#e3f5ea)}.fd-pi.ok .material-icons{font-size:17px;color:var(--plk-success,#2f9e5f)}
.fd-pi.err{background:var(--plk-danger-soft,#fbe6e5)}.fd-pi.err .material-icons{font-size:17px;color:var(--plk-danger,#b42318)}
.fd-spin{width:15px;height:15px;border-radius:50%;border:2px solid var(--plk-border-strong,#ded7cf);border-top-color:var(--plk-accent,#ff6358);animation:fd-spin .7s linear infinite;display:inline-block}
.fd-rmeta{flex:1;min-width:0}
.fd-rmeta b{display:block;font-size:13px;color:var(--plk-text,#1c1b22)}
.fd-rmeta span{font-size:11px;color:var(--plk-text-muted,#7d7b88);font-family:ui-monospace,Menlo,monospace;word-break:break-all}
.fd-rst{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.4px;white-space:nowrap}
.fd-rst.created{color:var(--plk-success,#2f9e5f)}.fd-rst.failed{color:var(--plk-danger,#b42318)}
.fd-rst.creating,.fd-rst.scheduled{color:var(--plk-text-muted,#7d7b88)}
.fd-rerr{flex-basis:100%;margin:2px 0 0 38px;font-size:11.5px;color:var(--plk-danger,#b42318);line-height:1.4}
`;
if (typeof document !== "undefined") {
  let el = document.getElementById("fd-styles");
  if (!el) {
    el = document.createElement("style");
    el.id = "fd-styles";
    document.head.appendChild(el);
  }
  el.textContent = FD_CSS;
}

// What a client can do about a provider rejection, keyed on the worker's reason text.
const cellGuidance = reason => {
  const r = String(reason || "").toLowerCase();
  if (/interest|criterion|audience|segment|user_list|userlist/.test(r)) return "An audience segment couldn't attach — the campaign still runs on the rest of your targeting. Edit the flight's Audiences to adjust.";
  if (/page|instagram/.test(r)) return "Add a valid Facebook Page ID in the Channels step, then retry.";
  if (/budget/.test(r)) return "Raise the daily budget for this market and retry.";
  if (/image|creative|asset|dimension|aspect/.test(r)) return "Re-upload the creative for this channel in the Creative step, then retry.";
  if (/headline|description|copy|text/.test(r)) return "Add ad copy (headline + description) in the Creative step, then retry.";
  if (/permission|access|auth|denied|token/.test(r)) return "The ad account needs to grant Plunk access — check provider settings.";
  return null;
};
const isAdmin = () => ((account.get() || {}).groups || []).some(g => ["owner", "administrator", "root"].includes(String(g).toLowerCase()));
const isPlatformAdmin = () => ((account.get() || {}).groups || []).some(g => ["administrator", "root"].includes(String(g).toLowerCase()));
class FlightDetailView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "load", () => {
      adSvc(`/flights/${this.id()}`).getAsync().then(f => {
        if (!this._alive) return;
        this.setState({
          flight: f
        });
        if (f.status === "Draft") this.loadManifest();else this.schedulePoll(f);
      }).catch(() => this.setState({
        error: true
      }));
    });
    _defineProperty(this, "uploadSlot", async (channel, slotKey, tier, file) => {
      this.setState({
        uploadingSlot: `${channel}|${slotKey}|${tier}`,
        note: null
      });
      try {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("channel", channel);
        fd.append("slotKey", slotKey);
        fd.append("tier", tier);
        const res = await fetch(`${endpoints.product.root}/campaign/ad/flights/${this.id()}/creative`, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + (AuthBase.idToken || ""),
            "x-app-id": (account.get() || {}).tenantId
          },
          body: fd
        });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw {
          message: body?.error || `Upload failed (${res.status})`
        };
        this.loadManifest();
      } catch (e) {
        this.setState({
          note: e.message || "Upload failed."
        });
      }
      this.setState({
        uploadingSlot: null
      });
    });
    // §354: Draft flights edit via the prefilled wizard + delete; a fully-
    // failed submission (no live campaigns) can also be deleted; Failed
    // cells re-enqueue idempotently via /retry.
    _defineProperty(this, "deleteFlight", async () => {
      this.setState({
        deleting: true,
        note: null
      });
      try {
        await adSvc(`/flights/${this.id()}`).deleteAsync();
        this.props.history.push("/Campaigns/Flights");
      } catch (e) {
        let msg = "Delete failed.";
        try {
          const b = JSON.parse(e.message);
          if (b.error) msg = b.error;
        } catch (x) {/* raw */}
        this.setState({
          deleting: false,
          confirmDelete: false,
          note: msg
        });
      }
    });
    _defineProperty(this, "retryFailed", async () => {
      this.setState({
        retrying: true,
        note: null
      });
      try {
        await adSvc(`/flights/${this.id()}/retry`).postAsync({});
      } catch (e) {/* poll shows outcome */}
      this.setState({
        retrying: false
      });
      this.load();
    });
    // Pause / resume the WHOLE flight — fans out to every live campaign server-side.
    _defineProperty(this, "setFlightStatus", async status => {
      this.setState({
        flightBusy: true,
        note: null
      });
      try {
        await adSvc(`/flights/${this.id()}/status?status=${status}`).putAsync({});
        this.setState({
          note: `Flight ${status === "Paused" ? "paused" : "resumed"} — the change syncs to every campaign within a few minutes.`
        });
      } catch (e) {
        this.setState({
          note: "Could not queue the flight status change — try again."
        });
      }
      this.setState({
        flightBusy: false
      });
    });
    _defineProperty(this, "validate", async () => {
      this.setState({
        validating: true,
        note: null
      });
      try {
        this.setState({
          report: await adSvc(`/flights/${this.id()}/validate`).postAsync({}),
          validating: false
        });
      } catch (e) {
        this.setState({
          validating: false,
          note: "Validation failed — try again."
        });
      }
    });
    _defineProperty(this, "submit", async () => {
      this.setState({
        submitting: true,
        note: null
      });
      try {
        await adSvc(`/flights/${this.id()}/submit`).postAsync({});
        this.setState({
          submitting: false,
          report: null
        });
        this.load();
      } catch (e) {
        let report = null;
        try {
          report = JSON.parse(e.message);
        } catch (x) {/* not a report */}
        if (report && (report.flightErrors || report.cells)) this.setState({
          report,
          submitting: false
        });else this.setState({
          submitting: false,
          note: "Submit failed — run Validate for details."
        });
      }
    });
    this.state = {
      flight: null,
      error: false,
      manifest: null,
      uploadingSlot: null,
      report: null,
      validating: false,
      submitting: false,
      note: null,
      confirmDelete: false,
      deleting: false,
      retrying: false,
      flightBusy: false
    };
    this._alive = true;
  }
  id() {
    return String(this.props.params && this.props.params.id || "");
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._pollTimer);
  }
  schedulePoll(f) {
    const cells = f.cells || [];
    const done = cells.length > 0 && cells.every(c => ["Created", "Failed"].includes(c.status || c.Status));
    if (!done) this._pollTimer = setTimeout(this.load, 8000);
  }
  loadManifest() {
    adSvc(`/flights/${this.id()}/manifest`).getAsync().then(d => this._alive && this.setState({
      manifest: d?.manifest || []
    })).catch(() => this._alive && this.setState({
      manifest: []
    }));
  }
  render() {
    if (!hasTenantFeature("campaigns")) return /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "module-empty"
    }, "Campaigns isn't configured for this workspace."));
    const {
      flight,
      error,
      manifest,
      uploadingSlot,
      report,
      validating,
      submitting,
      note
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!flight) return /*#__PURE__*/React.createElement(Loader, null);
    const money = adBillingMode() === "selfmanaged" || isPlatformAdmin();
    const admin = isAdmin();
    const cells = flight.cells || [];
    const st = c => c.status || c.Status || "Scheduled";
    const counts = cells.reduce((a, c) => {
      a[st(c)] = (a[st(c)] || 0) + 1;
      return a;
    }, {});
    // Retries run async on the worker: after /retry enqueues, the failed cells go
    // back to a non-terminal state and re-process one at a time. Keep the Retry
    // button disabled until every cell is terminal again (Created/Failed) — same
    // signal the poll uses — so it can't be re-fired mid-batch (double-enqueue).
    const inProgress = cells.some(c => !["Created", "Failed"].includes(st(c)));
    const markets = (flight.markets || []).map(m => m.Name || m.name).filter(Boolean);
    // §354: delete covers drafts AND flights with no live campaigns
    // (e.g. every cell Failed / CompletedWithErrors). The server 400s
    // with a friendly message if live campaigns exist — this gate just
    // hides the button in the obvious-no cases.
    const deletable = flight.status === "Draft" || flight.status === "CompletedWithErrors" || cells.length > 0 && cells.every(c => st(c) === "Failed");
    // A flight with any created provider campaign can be paused/resumed and soft-deleted
    // (delete pauses every campaign, then hides the flight — history kept).
    const hasLive = cells.some(c => c.campaignId != null || c.CampaignId != null);
    const statusPill = /error|fail/i.test(flight.status) ? "err" : flight.status === "Draft" ? "info" : /complete|enabled/i.test(flight.status) ? "ok" : "warn";
    const scheduleStr = flight.startDate || flight.endDate ? `${String(flight.startDate || "immediate").slice(0, 10)} → ${String(flight.endDate || "no end").slice(0, 10)}` : "—";
    const totalCells = cells.length;
    const createdCells = counts.Created || 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view campaigns-view wa-view"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Campaigns"
      }, "Campaigns"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
        to: "/Campaigns/Flights"
      }, "Flights"), " \xB7 Flight"),
      title: flight.eventName || flight.name,
      subtitle: `${(flight.channels || []).join(" · ") || "no channels"} · ${markets.join(" · ") || "no markets"} · ${scheduleStr}`,
      chips: [{
        k: "Status",
        v: flight.status
      }],
      actions: /*#__PURE__*/React.createElement(React.Fragment, null, admin && flight.status === "Draft" && /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        onClick: () => this.props.history.push(`/Campaigns/FlightBuilder/${this.id()}`)
      }, "Edit in builder"), admin && hasLive && !this.state.confirmDelete && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        disabled: this.state.flightBusy || inProgress,
        title: inProgress ? "Available once every campaign has finished launching" : "",
        onClick: () => this.setFlightStatus("Paused")
      }, "Pause flight"), /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        disabled: this.state.flightBusy || inProgress,
        title: inProgress ? "Available once every campaign has finished launching" : "",
        onClick: () => this.setFlightStatus("Enabled")
      }, "Resume")), admin && (deletable || hasLive) && (this.state.confirmDelete ? /*#__PURE__*/React.createElement("span", {
        style: {
          display: "inline-flex",
          gap: 6,
          alignItems: "center",
          fontSize: 12.5,
          color: "var(--plk-text-muted,#7d7b88)"
        }
      }, hasLive ? "Remove this flight?" : `Delete this ${flight.status === "Draft" ? "draft" : "failed flight"}?`, /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-error",
        disabled: this.state.deleting,
        onClick: this.deleteFlight
      }, this.state.deleting ? "Removing…" : hasLive ? "Yes, remove" : "Yes, delete"), /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        onClick: () => this.setState({
          confirmDelete: false
        })
      }, "Cancel")) : /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-error",
        disabled: inProgress,
        title: inProgress ? "Available once every campaign has finished launching" : "",
        onClick: () => this.setState({
          confirmDelete: true
        })
      }, hasLive ? "Remove flight" : "Delete")))
    }), note && /*#__PURE__*/React.createElement("div", {
      className: "wa-notice"
    }, note), /*#__PURE__*/React.createElement(Ribbon, {
      comparing: null,
      cols: 4,
      tiles: [{
        l: "Channels",
        v: String((flight.channels || []).length || 0),
        s: (flight.channels || []).join(" · ") || "none"
      }, {
        l: "Markets",
        v: String(markets.length),
        s: markets.join(" · ") || "none"
      }, flight.status !== "Draft" ? {
        l: "Campaigns",
        v: `${createdCells} of ${totalCells}`,
        s: "live at the ad platforms"
      } : {
        l: "Schedule",
        v: scheduleStr
      }, flight.landingPage ? {
        l: "Landing page",
        v: /*#__PURE__*/React.createElement("a", {
          href: flight.landingPage,
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            fontSize: 14,
            wordBreak: "break-all"
          }
        }, flight.landingPage.replace(/^https?:\/\//, "")),
        s: flight.status !== "Draft" ? scheduleStr : null
      } : {
        l: "Schedule",
        v: scheduleStr
      }].filter((t, i, arr) => arr.findIndex(x => x.l === t.l) === i)
    }), flight.status === "Draft" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
      title: "Creative",
      hint: "drop images into slots"
    }, manifest === null ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading slot manifest\u2026") : manifest.length === 0 ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "No image slots for the selected channels.") : manifest.map(ch => /*#__PURE__*/React.createElement("div", {
      key: ch.channel,
      style: {
        marginBottom: 14
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: 13,
        margin: "0 0 6px"
      }
    }, /*#__PURE__*/React.createElement("b", null, ch.channel)), /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Slot"), Object.keys((ch.slots[0] || {}).uploaded || {
      shared: 1
    }).map(t => /*#__PURE__*/React.createElement("th", {
      key: t
    }, t === "shared" ? "" : t)))), /*#__PURE__*/React.createElement("tbody", null, ch.slots.map(slot => /*#__PURE__*/React.createElement("tr", {
      key: slot.slotKey
    }, /*#__PURE__*/React.createElement("td", null, slot.order, " \xB7 ", slot.label, slot.shared ? " (shared)" : ""), Object.entries(slot.uploaded).map(([tier, url]) => /*#__PURE__*/React.createElement("td", {
      key: tier
    }, url ? /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: "",
      style: {
        height: 34,
        borderRadius: 4
      }
    }), " \u2713") : admin ? /*#__PURE__*/React.createElement("label", {
      className: "rep-state-chip",
      style: {
        cursor: uploadingSlot ? "wait" : "pointer"
      }
    }, uploadingSlot === `${ch.channel}|${slot.slotKey}|${tier}` ? "uploading…" : "drop image", /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: "image/jpeg,image/png",
      hidden: true,
      onChange: e => e.target.files?.[0] && this.uploadSlot(ch.channel, slot.slotKey, tier, e.target.files[0])
    })) : /*#__PURE__*/React.createElement("span", {
      className: "territory-hint"
    }, "missing")))))))))), /*#__PURE__*/React.createElement(Card, {
      title: "Review",
      hint: "nothing enqueues until every check passes"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center",
        flexWrap: "wrap",
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      disabled: validating,
      onClick: this.validate
    }, validating ? "Validating…" : "Validate"), admin && /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: submitting || !report || !report.isValid,
      onClick: this.submit,
      title: !report ? "Run Validate first" : report.isValid ? undefined : "Fix the errors below first"
    }, submitting ? "Submitting…" : "Create flight"), report && money && report.dailyBudgetTotal != null && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 12.5
      }
    }, "up to ", usd(report.dailyBudgetTotal), "/day across ", report.campaignCount, " campaigns")), report && /*#__PURE__*/React.createElement("div", null, (report.flightErrors || []).map((e, i) => /*#__PURE__*/React.createElement("p", {
      key: i,
      className: "territory-hint",
      style: {
        borderLeft: "3px solid #dc2626",
        paddingLeft: 10,
        margin: "0 0 6px"
      }
    }, /*#__PURE__*/React.createElement("b", null, e.field, ":"), " ", e.message, /wallet/i.test(`${e.field} ${e.message}`) && !ownAdAccounts() && /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("a", {
      href: "https://account.plunk.io/?from=app#wallet",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Add funds \u2014 Ad Wallet \u2197")))), (report.cells || []).filter(c => !c.isValid).slice(0, 20).map((c, i) => /*#__PURE__*/React.createElement("p", {
      key: i,
      className: "territory-hint",
      style: {
        margin: "0 0 4px"
      }
    }, /*#__PURE__*/React.createElement("b", null, c.market, " \xB7 ", c.channel, c.tier && c.tier !== "shared" ? ` · ${c.tier}` : "", ":"), " ", (c.errors || []).map(e => e && e.message || e).join("; "))), (report.warnings || []).map((w, i) => /*#__PURE__*/React.createElement("p", {
      key: `w${i}`,
      className: "territory-hint",
      style: {
        borderLeft: "3px solid #f59e0b",
        paddingLeft: 10,
        margin: "0 0 6px"
      }
    }, /*#__PURE__*/React.createElement("b", null, w.field, ":"), " ", w.message)), report.isValid && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        borderLeft: "3px solid #22c55e",
        paddingLeft: 10
      }
    }, "All checks pass \u2014 ", report.campaignCount, " campaigns will be created, queued and rate-limited.")))) : (() => {
      const failed = counts.Failed || 0;
      const settled = createdCells + failed;
      const done = totalCells > 0 && settled === totalCells;
      const pct = totalCells ? Math.round(settled / totalCells * 100) : 0;
      const title = !totalCells ? "Preparing campaigns…" : done ? failed ? `${failed} campaign${failed === 1 ? "" : "s"} failed to launch` : "Your flight is live" : failed ? `Creating campaigns, ${failed} failed so far` : "Creating campaigns…";
      return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("div", {
        className: "fd-hero"
      }, /*#__PURE__*/React.createElement("div", {
        className: `fd-ring ${done && !failed ? "done" : done && failed ? "fail" : ""}`,
        style: {
          "--pct": pct
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "fd-ring-in"
      }, done && !failed ? /*#__PURE__*/React.createElement("span", {
        className: "material-icons",
        style: {
          fontSize: 28,
          color: "var(--plk-success,#2f9e5f)"
        }
      }, "check") : done && failed ? /*#__PURE__*/React.createElement("span", {
        className: "material-icons",
        style: {
          fontSize: 28,
          color: "var(--plk-danger,#d64541)"
        }
      }, "priority_high") : /*#__PURE__*/React.createElement("span", {
        className: "pct"
      }, pct, "%"))), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          minWidth: 220
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: failed ? "fail" : ""
      }, title), /*#__PURE__*/React.createElement("p", null, !totalCells ? "Queuing campaigns…" : `${createdCells} of ${totalCells} campaign${totalCells === 1 ? "" : "s"} live${failed ? `. ${failed} ${failed === 1 ? "was" : "were"} rejected by the ad network: see Needs attention below.` : "."}`, !done && totalCells ? " Each is built one at a time (~30s apart); progress continues server-side." : "")), admin && failed > 0 && /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
        disabled: this.state.retrying || inProgress,
        onClick: this.retryFailed,
        title: "Re-enqueues only the failed campaigns \u2014 existing ones are skipped (idempotent)"
      }, this.state.retrying ? "Retrying…" : inProgress ? "Processing…" : `Retry ${failed} failed`)), (() => {
        // Matrix: one row per market, one column per channel (and
        // audience set when there is more than one). Failures are
        // grouped by reason underneath, since one provider rejection
        // usually hits every market the same way.
        const norm = c => String(st(c)).toLowerCase();
        const chanOf = c => c.channel || c.Channel || "";
        const tierOf = c => c.tier || c.Tier || "Core";
        const mktOf = c => c.market || c.Market || "";
        const multiTier = new Set(cells.map(tierOf)).size > 1;
        const colKey = c => multiTier ? `${chanOf(c)} · ${tierOf(c)}` : chanOf(c);
        const cols = [];
        const rows = [];
        const at = {};
        cells.forEach(c => {
          const k = colKey(c),
            m = mktOf(c);
          if (!cols.includes(k)) cols.push(k);
          if (!rows.includes(m)) rows.push(m);
          at[`${m}|${k}`] = c;
        });
        const pill = c => {
          if (!c) return /*#__PURE__*/React.createElement(Pill, {
            tone: "neutral"
          }, "Queued");
          const x = norm(c);
          const retrying = /^retrying/i.test(String(c.reason || c.Reason || ""));
          return x === "created" ? /*#__PURE__*/React.createElement(Pill, {
            tone: "success"
          }, "Live") : x === "failed" ? /*#__PURE__*/React.createElement("span", {
            className: "wa-pill danger solid"
          }, "Failed") : x === "creating" ? /*#__PURE__*/React.createElement(Pill, {
            tone: "info"
          }, retrying ? "Retrying" : "Creating") : /*#__PURE__*/React.createElement(Pill, {
            tone: "neutral"
          }, "Queued");
        };
        const groups = {};
        cells.filter(c => norm(c) === "failed").forEach(c => {
          const r = c.reason || c.Reason || "The provider rejected this campaign.";
          (groups[r] = groups[r] || []).push(c);
        });
        if (cells.length === 0) return /*#__PURE__*/React.createElement("p", {
          className: "territory-hint",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "fd-spin"
        }), " Preparing campaigns.");
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          style: {
            overflowX: "auto"
          }
        }, /*#__PURE__*/React.createElement("table", {
          className: "territory-table wa-table fd-mx"
        }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Market"), cols.map(k => /*#__PURE__*/React.createElement("th", {
          key: k
        }, k)))), /*#__PURE__*/React.createElement("tbody", null, rows.map(m => /*#__PURE__*/React.createElement("tr", {
          key: m
        }, /*#__PURE__*/React.createElement("td", {
          className: "m"
        }, m), cols.map(k => {
          const c = at[`${m}|${k}`];
          const r = c && norm(c) === "failed" ? c.reason || c.Reason || "" : "";
          return /*#__PURE__*/React.createElement("td", {
            key: k,
            title: r
          }, pill(c));
        })))))), Object.keys(groups).length > 0 && /*#__PURE__*/React.createElement("div", {
          className: "fd-fails"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fd-fails-h"
        }, "Needs attention"), Object.keys(groups).map(r => /*#__PURE__*/React.createElement("div", {
          key: r,
          className: "fd-fail"
        }, /*#__PURE__*/React.createElement("span", {
          className: "fd-pi err"
        }, /*#__PURE__*/React.createElement("span", {
          className: "material-icons"
        }, "priority_high")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, groups[r].map(c => `${chanOf(c)}${multiTier ? ` · ${tierOf(c)}` : ""} · ${mktOf(c)}`).join(", ")), /*#__PURE__*/React.createElement("div", {
          className: "why"
        }, /*#__PURE__*/React.createElement("b", null, "Why:"), " ", r, cellGuidance(r) ? ` ${cellGuidance(r)}` : ""))))));
      })());
    })()));
  }
}
const Routable = withRouter(FlightDetailView);
export default class FlightDetailViewComponent extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Routable, {
      params: this.props.params
    });
  }
}